import { pageId } from "utils/pageId";

export default () => ({
    deployments: pageId("Project.Deployments", "Deployments"),
    deployment: pageId("Project.Deployment", "Deployment"),
});